import React from "react";

const FormHeader = (props: any) => {
    return (
        <div className="title">
            {props.title}
        </div>
    );
}

export default FormHeader;